'use client';

import { createPortal } from 'react-dom';

import StoreConfig from '@/config';
import { HREFLANG_CATEGORY_URL_KEYS } from '@/constants/hreflang-category-url-keys';
import { usePathname } from 'next/navigation';
import { ReactNode } from 'react';

interface Props {
  isProductPage?: boolean;
  isCategoryPage?: boolean;
  productCategories?: any[];
  isConfigurableProduct?: boolean;
  productUrl?: string;
}

const HrefLangLinks = (props: Props) => {
  const { isProductPage = false, isCategoryPage = false, productCategories, isConfigurableProduct, productUrl } = props;

  const pathname = usePathname();

  if (isProductPage) {
    // 分类 /swatches 或者 /fabrics
    const isSwatch = productCategories?.some(x => x?.uid === 'NDI=' || x?.uid === 'NDM=');

    if (isConfigurableProduct && !isSwatch) {
      return null;
    }
  }

  if (isCategoryPage) {
    const currentUrlKey = pathname.split('/').filter(Boolean)[0];

    if (!HREFLANG_CATEGORY_URL_KEYS.includes(currentUrlKey)) {
      return null;
    }
  }

  return createPortal(
    StoreConfig.available_countries.reduce<ReactNode[]>((acc, x) => {
      if (x.sharedLanguageSite && !x.defaultSharedLanguageSite) {
        return acc;
      }

      let nextPathname = isProductPage ? productUrl || '' : pathname;

      if (isCategoryPage) {
        if (x.code === 'uk') {
          nextPathname = nextPathname
            .replace('/colors-family', '/colours-family')
            .replace('/fall-wedding-guest-dresses', '/autumn-wedding-guest-dresses');
        } else {
          if (x.code === 'au') {
            nextPathname = nextPathname.replace('/fall-wedding-guest-dresses', '/autumn-wedding-guest-dresses');
          } else {
            nextPathname = nextPathname.replace('/autumn-wedding-guest-dresses', '/fall-wedding-guest-dresses');
          }

          nextPathname = nextPathname.replace('/colours-family', '/colors-family');
        }
      }

      if (nextPathname === '/') {
        nextPathname = '';
      }

      if (x.code === 'us') {
        acc.push(
          <link
            rel='alternate'
            hrefLang='x-default'
            key='x-default'
            href={`${x.url}${nextPathname}`}
          />,
        );
      }

      acc.push(
        <link
          rel='alternate'
          hrefLang={x.hreflang}
          key={x.code}
          href={`${x.url}${nextPathname}`}
        />,
      );

      return acc;
    }, []),
    document.head,
  );
};

export default HrefLangLinks;
